/**
 * Empty State Component
 * Empty state messages with icon and action support
 */
import React from 'react';
import { Inbox, Plus } from 'lucide-react';
import { Button } from './Button';

export interface EmptyStateProps {
  icon?: React.ComponentType<{ size?: number | string; className?: string }>;
  iconClassName?: string;
  title: string;
  message: string;
  action?: {
    label: string;
    onClick: () => void;
    icon?: React.ComponentType<{ size?: number | string; className?: string }>;
  };
  className?: string;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  icon: Icon,
  iconClassName = '',
  title,
  message,
  action,
  className = '',
}) => {
  const DefaultIcon = Icon || Inbox;
  const ActionIcon = action?.icon || Plus;

  return (
    <div className={`flex flex-col items-center justify-center py-12 px-4 text-center ${className}`}>
      <div className="mb-4 p-4 rounded-full bg-slate-100 dark:bg-slate-800">
        <DefaultIcon size={48} className={`text-slate-400 dark:text-slate-500 ${iconClassName}`} />
      </div>
      <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">{title}</h3>
      <p className="text-sm text-slate-500 dark:text-slate-400 max-w-md mb-6">{message}</p>
      {action && (
        <Button
          onClick={action.onClick}
          leftIcon={<ActionIcon size={16} />}
        >
          {action.label}
        </Button>
      )}
    </div>
  );
};

